import React from 'react';
import InfoCard from 'src/components/InfoCard';
import { Checkbox } from '@Thread-Magic/jasmine';
import PropTypes from 'prop-types';
import AutoExpandTextarea from 'src/components/AutoExpandTextarea';
import * as Styled from './style';
import { IntentField, IntentFieldGroup } from '../style';

const TYPE_CONTENT = {
  internal: {
    title: 'Internal Reply',
    label: 'What the internal reply should say',
    placeholder: 'Let the AI answer with a link or specific reply.',
    description:
      'This is the reply the Agent will send to internal team members. You can share a link to a knowledge base article.'
  },
  external: {
    title: 'External Reply',
    label: 'Describe what the AI should reply',
    placeholder: 'Let the AI answer with a link or specific reply, you can also use prompts.',
    description:
      'This is the reply the Agent will send to the contact. You can send a link to a help article or external form.',
    hasResolutionField: true
  }
};

export default function IntentReply({ data, onChange, type = 'external' }) {
  const content = TYPE_CONTENT[type];
  return (
    <Styled.ReplyWrapper>
      <p>
        {content.title} <span>(Optional)</span>
      </p>
      <InfoCard>{content.description}</InfoCard>
      <IntentFieldGroup>
        <IntentField>
          <p>{content.label}</p>
          <AutoExpandTextarea
            value={data.description}
            onChange={e => {
              onChange({ description: e.target.value });
            }}
            placeholder={content.placeholder}
          />
        </IntentField>
        {content.hasResolutionField && (
          <IntentField>
            <p>This is a resolution</p>
            <Checkbox
              className={`resolution-checkbox-${type}`}
              id={`resolution-checkbox-${type}`}
              checked={data.is_resolution}
              onChange={() => {
                onChange({ is_resolution: !data.is_resolution });
              }}
            >
              Close the request if the customer confirms
            </Checkbox>
          </IntentField>
        )}
      </IntentFieldGroup>
    </Styled.ReplyWrapper>
  );
}

IntentReply.propTypes = {
  data: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['internal', 'external'])
};

IntentReply.defaultProps = {
  type: 'external',
  data: {}
};
